export default __webpack_public_path__ + "static/media/carousel-airport-express.11534854.jpg";